import { CommonModule } from '@angular/common';
import { Component, effect, input, viewChild } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { DxButtonModule, DxFormComponent, DxFormModule, DxTabsModule, DxTooltipModule } from 'devextreme-angular';
import { FormPopupComponent } from 'src/app/components/utils/form-popup/form-popup.component';
import { ListFilterTabsController } from 'src/app/shared/helpers/list-filter-tabs.controller';

/**
 * Shared list filter-tabs UI (add button, tabs, create-tab popup).
 * Bind a page-owned {@link ListFilterTabsController}.
 */
@Component({
    selector: 'app-list-filter-tabs',
    standalone: true,
    imports: [CommonModule, DxButtonModule, DxTabsModule, DxTooltipModule, DxFormModule, TranslocoPipe, FormPopupComponent],
    templateUrl: './list-filter-tabs.component.html',
    styleUrl: './list-filter-tabs.component.scss',
})
export class ListFilterTabsComponent {
    readonly controller = input.required<ListFilterTabsController>();

    private readonly createFilterTabForm = viewChild<DxFormComponent>('createFilterTabForm');

    constructor() {
        effect(() => {
            const controller = this.controller();
            // Re-register when controller input changes; form may be absent until popup opens.
            controller.attachCreateFilterTabForm(() => this.createFilterTabForm());
        });
    }
}
